import { render, staticRenderFns } from "./newTraslado.vue?vue&type=template&id=70c4eea4"
import script from "./newTraslado.vue?vue&type=script&lang=js"
export * from "./newTraslado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports